module.exports = __webpack_public_path__ + "media/images/footer_insta-3db71093.png";